// /* eslint-disable no-param-reassign */
import './index.css';
import Project from "./Experience/Project"
const project = new Project()